module.exports = __webpack_public_path__ + "static/media/x.27d1aaa7.svg";